import { useRef, useCallback, forwardRef, useImperativeHandle } from 'react';
import DataSourceList from '../../../../dataBinding/DataSourceList';
import DataWrapperComponent from '../../../../dataBinding/DataWrapper';
import Select from './Select';
import { useGridCellEditor } from 'ag-grid-react';

const DropdownEditor = forwardRef((props, ref) => {
  const selectRef = useRef(null);
  const selectValueRef = useRef(null);
  const isEditingCompletedRef = useRef(false);

  const isCancelAfterEnd = useCallback(() => {
    if (isEditingCompletedRef.current) return true; // Returning true to avoid setting new value
    isEditingCompletedRef.current = true; // prevent further commits
    props.onValueChange?.(selectValueRef.current);
    return false;
  }, [props.onValueChange]);

  const focusInput = () => {
    if (selectRef?.current?.select) {
      selectRef.current.select?.focus?.();
    }
  };

  const clearValue = () => {
    if (selectRef?.current?.select?.select) {
      selectRef.current.select.select?.clearValue?.();
    }
  };

  const afterGuiAttached = () => {
    focusInput();
  };

  useGridCellEditor({
    isCancelAfterEnd,
    afterGuiAttached
  });

  useImperativeHandle(ref, () => ({
    getValue: () => {
      return selectValueRef.current;
    },
    focusInput,
    clearValue
  }));

  const handleUpdate = useCallback(
    (newValue) => {
      const finalValue = newValue === undefined ? null : newValue;
      selectValueRef.current = finalValue;
      props.onChange?.(finalValue);
    },
    [props.onChange]
  );

  const optionsFieldName =
    props.column.colDef.cellEditorParams?.editorFieldName || props.column.colDef.field;

  const { storeName, storeVariable } = DataSourceList[optionsFieldName] ?? {};

  return (
    <DataWrapperComponent
      wrappedComponent={Select}
      componentProps={{
        ...props,
        value: props.formatValue?.() ?? props.initialValue ?? props.value,
        onChange: handleUpdate,
        inputRef: selectRef
      }}
      storeName={storeName}
      storeVariable={storeVariable}
    />
  );
});

export default DropdownEditor;
